import React, { useCallback, useMemo } from 'react'

import Padding from 'components/Editor/Toolbar/Padding'
import { LayoutScroll } from 'components/LayoutPage'
import { FormField } from 'components/formKit'
import { Typography } from 'components/uiKit/Typography'
import { BrandGoBack } from 'services/Branding/components'
import { FEEDBACK_SCHEMA_FIELDS } from 'services/Branding/fieldConfigs'
import { useUpdateSchema } from 'services/Branding/hooks'
import { BrandFormEnum } from 'services/Branding/types'
import { t } from 'services/Translation'

import type { GroupingFormBrandType } from './groupingTypes'

const GroupingFormFeedback: GroupingFormBrandType = ({ device, subConfigs, setForm }) => {
  const stylePath = useMemo(() => ['feedback', device], [device])
  const schema = useUpdateSchema(stylePath, subConfigs, FEEDBACK_SCHEMA_FIELDS)

  const handleGoBack = useCallback(() => setForm?.(BrandFormEnum.STYLE), [setForm])

  return (
    <LayoutScroll sizeAutoCapable>
      <Padding bottom bottomSpace gap sides>
        <BrandGoBack onClick={handleGoBack} />
        <Typography weight='medium'>{t('elements.testAnswerFeedback.tags.correct')}</Typography>
        <FormField config={schema.correct.backgroundImage} />
        <FormField config={schema.correct.backgroundColor} />
        <FormField config={schema.correct.color} />
        <FormField config={schema.incorrect.backgroundImage} />
        <FormField config={schema.incorrect.backgroundColor} />
        <FormField config={schema.incorrect.color} />
        <FormField config={schema.common__var.width} />
        <FormField config={schema.common__var.height} />
      </Padding>
    </LayoutScroll>
  )
}

export default React.memo(GroupingFormFeedback) as typeof GroupingFormFeedback
